import { useEffect, useMemo } from 'react';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { Booth } from 'models/cms/booths';

const useBoothEnterTracking = (booth: Booth) => {
  const preparedData = useMemo(() => {
    if (booth?.name) {
      return {
        boothId: booth?.id,
        boothName: findAvailableLocale(booth?.name || {}, 'en'),
      };
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Boolean(booth?.name)]);

  useEffect(() => {
    if (preparedData) {
      const { boothId, boothName } = preparedData;
      window.trackingItemToFirebase(null, 'Booth', 'Enter', '', '', boothId, boothName);
    }
  }, [preparedData]);
};

export default useBoothEnterTracking;
